import Backbone from 'backbone'
import template from './conjunction-editor-examples-view.hbs'
import ConjunctionEditor from 'scoreboard/components/logic/conjunction-editor'
import TransformationIf from 'scoreboard/imports/transform/transformation-if'
import Dataset from 'scoreboard/datasets/model/dataset'
import dsaidSa from '../../tests/scoreboard/datasets/dsaid-sexual-assaults'
import FormView from 'scoreboard/components/form-view'
import $ from 'jquery'
import StatementType from 'scoreboard/components/logic/model/statement-type'
const { AND_OR } = StatementType

let fourConditionsExample = {
	statementType: AND_OR,
	conditions: [ {
		linkGroup: 0,
		fieldId: 7701, // alcohol involved
		operator: 'is-any',
		values: [ 'yes' ]
	}, {
		linkGroup: 1,
		fieldId: 705, // Date of Incident
		operator: 'not-blank'
	}, {
		linkGroup: 1,
		fieldId: 702, // Victim Age
		operator: 'less-than',
		value1: 3
	}, {
		linkGroup: 2,
		fieldId: 707, // Victim Pay Grade
		operator: 'contains-any',
		values: ['E'],
	} ]
}

const ConjunctionEditorExamplesView = Backbone.View.extend(/** @lends {ConjunctionEditorExamplesView} */{

	events: {
		'click .read-from-dom': 'onClickReadFromDom',
		'click .blank-example': 'onClickBlankExample',
		'click .four-conditions-example': 'onClickFourConditionsExample',
		'click .test': 'onClickTest'
	},

	render: function() {
		this.$el.html(template())

		this.formView = new FormView({ el: $('.display-pane') })

		this.onClickFourConditionsExample()

		return this
	},

	onClickTest: function() {
		console.log(this.conjunctionEditor?.test())
	},

	onClickReadFromDom: function() {
		console.dir(this.conjunctionEditor.readFromDom())
	},

	onClickBlankExample: function() {
		this.renderExample()
	},

	renderExample: function(conjunction) {
		this.conjunctionEditor?.remove()

		let model = new Dataset(dsaidSa)
		this.conjunctionEditor = new ConjunctionEditor({
			conjunction,
			conditionEditorCreator: condition => {
				return new TransformationIf({
					model,
					stronglyTyped: true,
					fields: model.get('fields'),
					formView: this.formView,
					transformation: {
						if: condition
					}
				})
			}
		})
		this.$('.panel').prepend(this.conjunctionEditor.el)
		this.conjunctionEditor.render()

		this.formView.start()

		this.onClickReadFromDom()
	},

	onClickFourConditionsExample: function() {
		this.renderExample(fourConditionsExample)
	},

	autoRemove: true

})

export default ConjunctionEditorExamplesView
